export interface HasId {
  id: number | string;
}

export interface UnitWithCommunity extends HasId {
  community?: { id: number | string } | null;
}

/** A user must keep at least one community; one (or zero) memberships means removing is the "last". */
export function isLastCommunity(communities: HasId[]): boolean {
  return communities.length <= 1;
}

export function unitsInCommunity<T extends UnitWithCommunity>(units: T[], communityId: number | string): T[] {
  return units.filter((u) => String(u.community?.id) === String(communityId));
}

/**
 * After removing a unit, offer to also remove the user from the community only
 * when it was their last unit there AND their role is a plain community_member
 * (no elevated reason to remain). Otherwise member-with-no-unit is a valid state.
 */
export function shouldPromptRemoveFromCommunity(args: {
  remainingUnitsInCommunity: number;
  communityRole: string | null | undefined;
}): boolean {
  return args.remainingUnitsInCommunity === 0 && args.communityRole === 'community_member';
}
